exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".filter-labels{color:#fff;margin:0 20px;-ms-flex:1!important;flex:1!important}.flex{display:-ms-flexbox;display:flex}.spread{width:unset!important;-ms-flex:1;flex:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-ee20422e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/shared/FilterInput.vue
// module id = 1040
// module chunks = 0